import { Controller } from '@hotwired/stimulus';

// POSTs pending dog attributes to Account::DogsController#plan_preview (same as
// Edit Dog's Confirm Changes modal) and fills the comparison table.
export default class extends Controller {
  static targets = [
    'form',
    'daily',
    'box',
    'price',
    'pricePerDay',
    'pending',
    'unavailable',
    'save',
  ];

  static values = { previewUrl: String };

  connect() {
    this.setSaveEnabled(false);
    this.loadPreview();
  }

  loadPreview() {
    if (!this.hasPreviewUrlValue || !this.hasFormTarget) return;
    this.setSaveEnabled(false);

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const body = new FormData(this.formTarget);

    fetch(this.previewUrlValue, {
      method: 'POST',
      headers: { 'X-CSRF-Token': token, Accept: 'application/json' },
      body,
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data?.interval_count) {
          this.showUnavailable();
          return;
        }

        if (this.hasDailyTarget && data.daily_cup_label) {
          this.dailyTarget.textContent = data.daily_cup_label;
        }
        if (this.hasBoxTarget && data.box_cadence_label) {
          this.boxTarget.textContent = data.box_cadence_label;
        }
        if (this.hasPriceTarget && data.price_per_order_cents != null) {
          this.priceTarget.textContent = this.formatMoney(data.price_per_order_cents);
        }
        if (this.hasPricePerDayTarget && data.price_per_day_label) {
          this.pricePerDayTarget.textContent = data.price_per_day_label;
        }
        this.pendingTargets.forEach((el) => el.classList.remove('m-compare__pending'));
        this.setSaveEnabled(true);
      })
      .catch(() => this.showUnavailable());
  }

  showUnavailable() {
    if (this.hasUnavailableTarget) this.unavailableTarget.hidden = false;
    this.setSaveEnabled(false);
  }

  setSaveEnabled(enabled) {
    if (!this.hasSaveTarget) return;
    this.saveTarget.disabled = !enabled;
  }

  formatMoney(cents) {
    const dollars = cents / 100;
    const precision = cents % 100 === 0 ? 0 : 2;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    }).format(dollars);
  }
}
